import _ from "lodash";
/** External */
import client from "lib/apolloClient/client";

import { getOrganizationCoursesQuery } from "./ClassPerformanceQueries";

export const getOrganizationCoursesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationCoursesQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};
